import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';
import classNames from 'classnames';
import styles from './SponsoredTile.module.styl';
import sizeImage from '../lib/sizeImage';
import makeSrcSet from '../lib/makeSrcSet';

const SponsoredTile = ({
  image,
  headline,
  href,
  imgAlt,
  isDisplayed,
  aspectRatio,
}) => {
  const imageSet = {
    large: sizeImage({
      src: image,
      widthAspect: aspectRatio,
      width: 1080,
    }),
    small: sizeImage({
      src: image,
      widthAspect: aspectRatio,
      width: 640,
    }),
  };

  const srcSet = makeSrcSet(image, undefined, { widthAspect: aspectRatio });

  return (
    <li className={classNames(styles.sponsoredTile, { [styles.isDisplayed]: isDisplayed })}>
     <a href="http://sponsored.bostonglobe.com/damore-mckim/business-skills-for-the-future" target="_blank" rel="noreferrer noopener" className={styles.tileLink}>
        <figure className={styles.tileBody}>
          <picture>
            <img
              src={`https://apps.bostonglobe.com/ideas/graphics/2021/04/the-future-of-work/header.jpeg`}
              alt={`The skills of tomorrow’s leaders`}
              data-object-fit="cover"
              srcSet={`https://apps.bostonglobe.com/ideas/graphics/2021/04/the-future-of-work/header.jpeg`}
              sizes="(max-width: 35em) 100vw; (max-width: 68em) 50vw; 16.5vw"
            />
          </picture>

          <h3 className={classNames(styles.headline, 'bentoncond-n4')}>Sponsored Content</h3>

          <figcaption>
            <h2 className={classNames(styles.headline, 'bentoncond-n4')}>
              The skills of tomorrow’s leaders
            </h2>
          </figcaption>
        </figure>
      </a>
    </li>
  );
};

SponsoredTile.propTypes = {
  headline: PropTypes.string.isRequired,
  href: PropTypes.string.isRequired,
  imgAlt: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  isDisplayed: PropTypes.bool,
  aspectRatio: PropTypes.number,
};

SponsoredTile.defaultProps = {
  isDisplayed: false,
  aspectRatio: null,
};

export default SponsoredTile;
